import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

/**
 * 入口 A（iPASS MONEY APP → 我們）跨頁狀態。
 *
 * - lockPayment：從 iPASS 進來的下單流程，付款方式固定 iPASS Money、不可切換
 * - prefill：一卡通共享過來的姓名／手機，給未註冊者的註冊流程預填
 *
 * 放 sessionStorage：LINE 登入來回、onboarding 多頁切換都要活著；關掉分頁就該清掉，
 * 下次從一般入口進來不能還被鎖在 iPASS。
 */
interface IPassEntryState {
  lockPayment: boolean;
  prefill: { name: string; phone: string } | null;
  setEntry: (v: { lockPayment: boolean; prefill: { name: string; phone: string } | null }) => void;
  clear: () => void;
}

export const useIPassEntry = create<IPassEntryState>()(
  persist(
    (set) => ({
      lockPayment: false,
      prefill: null,
      setEntry: (v) => set(v),
      clear: () => set({ lockPayment: false, prefill: null }),
    }),
    { name: "ipassEntry", storage: createJSONStorage(() => sessionStorage) },
  ),
);
